(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGallery(gallery) {
    var track = gallery.querySelector('.image-gallery__track');
    var items = Array.prototype.slice.call(gallery.querySelectorAll('.image-gallery__item'));
    var dotsContainer = gallery.querySelector('.image-gallery__dots');
    var dialog = gallery.querySelector('.image-gallery__lightbox');
    var dialogImg = dialog ? dialog.querySelector('.image-gallery__lightbox-img') : null;
    var closeBtn = dialog ? dialog.querySelector('.image-gallery__lightbox-close') : null;

    if (!track || !items.length) return;

    if (dotsContainer && items.length > 1) {
      var dots = Array.prototype.slice.call(dotsContainer.querySelectorAll('.image-gallery__dot'));
      var maxVisible = 5;

      function updateDots(activeIndex) {
        var total = dots.length;
        var half = Math.floor(maxVisible / 2);
        var start = Math.max(0, activeIndex - half);
        var end = start + maxVisible - 1;
        if (end >= total) {
          end = total - 1;
          start = Math.max(0, end - maxVisible + 1);
        }
        dots.forEach(function (dot, i) {
          if (i < start || i > end) {
            dot.dataset.state = 'hidden';
          } else {
            var dist = Math.abs(i - activeIndex);
            dot.dataset.state = dist === 0 ? 'active' : dist === 1 ? 'near' : 'far';
          }
        });
      }

      updateDots(0);

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
              var index = items.indexOf(entry.target);
              if (index > -1) updateDots(index);
            }
          });
        }, { root: track, threshold: 0.5 });
        items.forEach(function (item) { observer.observe(item); });
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          if (items[i]) {
            items[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        });
      });
    }

    if (dialog && dialogImg) {
      items.forEach(function (item) {
        item.addEventListener('click', function () {
          var src = item.dataset.fullSrc;
          if (!src) return;
          dialogImg.src = src;
          dialogImg.alt = '';
          dialog.showModal();
        });
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          dialog.close();
        });
      }

      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) dialog.close();
      });
    }
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('.image-gallery')).forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
